import { isFeatureEnabled } from 'owa-feature-flags';

// For notification channel, we issue an LTI token, this needs to be requested from OWA BE.
// For image proxy, we issue an STI token, this needs to be requested from OWA BE unless
// auth-entraid-tokens-imageproxy feature flag is enabled, in which case we fetch from Entra ID.
// No need to pass the user token in request body as these requests are not OBO requests.

/**
 * Checks if the resource is an image proxy resource (cosmicimg-sdf or cosmicimg-prod)
 */
function isImageProxyResource(resource: string): boolean {
    const lowerResource = resource.toLowerCase();
    return (
        lowerResource.indexOf('/cosmicimg-sdf.services.web.outlook.com') > 0 ||
        lowerResource.indexOf('/cosmicimg-prod.services.web.outlook.com') > 0
    );
}

export function shouldFetchFromSTS(resource: string): boolean {
    const outlookGatewayRequest = new RegExp('outlookgatewayb2/.*/graphql');
    const lowerResource = resource.toLowerCase();

    // Image proxy resources - check feature flag
    // When auth-imageproxy-entraId-token is enabled, use MSAL/Entra ID path (return false)
    // When disabled, use server path (return true)
    if (isImageProxyResource(resource)) {
        return !isFeatureEnabled('auth-imageproxy-entraId-token');
    }

    // Other STS resources always go through server
    return (
        (resource && lowerResource.indexOf('/notificationchannel') > 0) ||
        outlookGatewayRequest.test(lowerResource)
    );
}
